<mat-card class="card">
  <mat-card-header>
    <mat-card-title class="dialog-title">
      @if (attribute) {
        <ng-container i18n="@@editAttributeTooltip">Edit attribute</ng-container>
      } @else {
        <ng-container i18n="@@newAttribute">New Attribute</ng-container>
      }
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form" class="attribute-form">
      <mat-form-field>
        <mat-label i18n="@@attributeName">Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <mat-form-field>
        <mat-label i18n>Key</mat-label>
        <input matInput formControlName="key" />
        @if (attribute) {
          <mat-hint i18n="@@attributeKeyLockedHint">Key and type can't be changed: forms and formulas use them.</mat-hint>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label i18n="@@sort">Sort</mat-label>
        <input matInput type="number" formControlName="sort" />
      </mat-form-field>

      <mat-form-field>
        <mat-label i18n>select attribute type</mat-label>
        <mat-select formControlName="productAttributeType">
          @for (type of ProductCategoriesAtt | keyvalue; track type) {
          <mat-option [value]="+type.key">{{ type.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label i18n="@@attributeScope">Scope</mat-label>
        <mat-select formControlName="scope">
          @for (scope of scopes; track scope) {
          <mat-option [value]="scope">{{ scopeLabels[scope] }}</mat-option>
          }
        </mat-select>
        <mat-hint i18n="@@attributeScopeHint">Fixed: one value per product, usable in formulas. Editable: technicians fill it in for each device on forms.</mat-hint>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions class="dialog-actions">
    <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
      Close
    </button>
    <button
      matButton="elevated"
      color="accent"
      (click)="onSave()"
      [disabled]="!form.valid || form.pristine"
      i18n="@@buttonSave"
    >
      Save
    </button>
  </mat-card-actions>
</mat-card>
